import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  toggleSnackbar: false,
  snackbarMessage: null
};

const open = (state: any) => ({
  ...state,
  toggleSnackbar: true
});

const close = (state: any) => ({
  ...state,
  toggleSnackbar: false
});

export default createReducer(INITIAL_STATE, {
  [Types.TOGGLE_SNACKBAR_OPEN]: open,
  [Types.TOGGLE_SNACKBAR_CLOSE]: close
});
